/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loadText: NonNullable<unknown> }} Workout_Logging_Plates_NearestInputs */

const en_us2_workout_logging_plates_nearest = /** @type {(inputs: Workout_Logging_Plates_NearestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`nearest: ${i?.loadText}`)
};

const pt_br2_workout_logging_plates_nearest = /** @type {(inputs: Workout_Logging_Plates_NearestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`mais próximo: ${i?.loadText}`)
};

const es_419_workout_logging_plates_nearest = /** @type {(inputs: Workout_Logging_Plates_NearestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`más cercano: ${i?.loadText}`)
};

const pt_pt2_workout_logging_plates_nearest = /** @type {(inputs: Workout_Logging_Plates_NearestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`mais próximo: ${i?.loadText}`)
};

const fr_fr2_workout_logging_plates_nearest = /** @type {(inputs: Workout_Logging_Plates_NearestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`le plus proche : ${i?.loadText}`)
};

const de_de2_workout_logging_plates_nearest = /** @type {(inputs: Workout_Logging_Plates_NearestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`am nächsten: ${i?.loadText}`)
};

const it_it2_workout_logging_plates_nearest = /** @type {(inputs: Workout_Logging_Plates_NearestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`più vicino: ${i?.loadText}`)
};

/**
* | output |
* | --- |
* | "nearest: {loadText}" |
*
* @param {Workout_Logging_Plates_NearestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_plates_nearest = /** @type {((inputs: Workout_Logging_Plates_NearestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Plates_NearestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_plates_nearest(inputs)
	if (locale === "es-419") return es_419_workout_logging_plates_nearest(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_plates_nearest(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_plates_nearest(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_plates_nearest(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_plates_nearest(inputs)
	return en_us2_workout_logging_plates_nearest(inputs)
});
export { workout_logging_plates_nearest as "workout-logging.plates_nearest" }